import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";

export function LegalSection({ n, title, children }) {
  return (
    <section className="rounded-3xl border border-line bg-ink p-7 lg:p-9">
      <h2 className="font-display text-lg font-extrabold uppercase tracking-tight text-white">
        <span className="mr-3 font-mono text-xs text-neon">{n}</span>
        {title}
      </h2>
      <div className="mt-4 grid gap-3 text-sm leading-relaxed text-slate-400">{children}</div>
    </section>
  );
}

export default function LegalShell({ testid, title, children }) {
  useEffect(() => {
    document.title = `${title} — MAXREVIX`;
  }, [title]);
  return (
    <div className="min-h-screen bg-night text-white">
      <div className="noise-overlay" aria-hidden="true" />
      <header className="glass fixed inset-x-0 top-0 z-50 border-b border-line">
        <div className="mx-auto flex h-[72px] w-full max-w-7xl items-center justify-between px-5 lg:px-8">
          <Link data-testid="legal-logo-link" to="/"><Logo /></Link>
          <Link
            data-testid="legal-back-home-btn"
            to="/"
            className="flex items-center gap-2 rounded-full border border-line px-4 py-2.5 text-[13px] font-bold text-white transition-colors duration-200 hover:border-neon hover:text-neon"
          >
            <ArrowLeft size={15} className="text-neon" />
            Accueil
          </Link>
        </div>
      </header>

      <main className="relative mx-auto w-full max-w-3xl px-5 pb-24 pt-32 lg:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neon label-mono">MAXREVIX — Saint-Pierre-en-Faucigny</p>
        <h1 data-testid={`${testid}-title`} className="mt-3 font-display text-3xl font-extrabold uppercase tracking-tight sm:text-4xl">
          {title}
        </h1>
        <div className="mt-10 grid gap-5">{children}</div>
        <p className="mt-12 text-[11px] leading-relaxed text-slate-500">
          Document établi le 13/10/2026 — MAXREVIX, entreprise individuelle exploitée par Maxime Cros, 74800 Saint-Pierre-en-Faucigny, France.
        </p>
      </main>
    </div>
  );
}
